module.exports = __webpack_public_path__ + "img/tick.607c583f.svg";